export const editMixins = {
    methods: {
        closeExpirationModal() {
          this.expirationModal = false;
        }
      }
}